import paths from "@icarius-router/paths";
import { numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.taxTable],
        config: {
            headerName: getLocalizedString("rate"),
            field: "rate",
            cellEditor: "asyncValidationCodeEditor",
            cellEditorParams: {
                condition: (value) => {
                    return value && value.length < 20;
                }
            },
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
            isObligatory: true,
            maxLength: 20,
            minLength: 1
        }
    },
    {
        pages: [paths.taxTable],
        config: {
            headerName: getLocalizedString("pollTo"),
            field: "to",
            filterParams: numberFilterParams(),
            valueFormatter: createNumberFormatter(0, 3, true),
            isNumeric: true,
            isObligatory: true,
            dataType: "number"
        }
    },
    {
        pages: [paths.taxTable],
        config: {
            headerName: getLocalizedString("lowerPrice"),
            field: "reduction",
            filterParams: numberFilterParams(),
            valueFormatter: createNumberFormatter(0, 3, true),
            isNumeric: true,
            isObligatory: true,
            dataType: "number"
        }
    },
    {
        pages: [paths.taxTable],
        config: {
            headerName: getLocalizedString("factor"),
            field: "factor",
            filterParams: numberFilterParams(),
            valueFormatter: createNumberFormatter(0, 3, true),
            isNumeric: true,
            isObligatory: true,
            dataType: "number"
        }
    },
]